import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getCourseAssignmentUserCompletion as getCourseAssignmentUserCompletionFromMonolith } from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

const getCourseAssignmentUserCompletionSchema = z.object({
   wikiid: z.number().nullable(),
   userid: z.number().nullable(),
});

export async function getCourseAssignmentUserCompletion(
   wikiid: number | null,
   userid: number | null,
   options: CommonRequestOptions = {}
): Promise<{ completions: Record<number, number> }> {
   return await getCourseAssignmentUserCompletionFromMonolith(wikiid, userid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { wikiid, userid } = getCourseAssignmentUserCompletionSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCourseAssignmentUserCompletion(wikiid, userid, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCourseAssignmentUserCompletionFromClient = (
   wikiid: number | null,
   userid: number | null
): ReturnType<typeof getCourseAssignmentUserCompletion> => {
   return bff()
      .post(`/courses/view/assignees/getCourseAssignmentUserCompletion`, {
         wikiid,
         userid,
      })
      .then(response => response.data);
};

export type GetCourseAssignmentUserCompletionErrorCode =
   'courses.course_assignment_user_completion_not_found';
